<form class="filter-form leave-filter-popup" [formGroup]="filterService.LeaveSelectionMoreFilterForm">

  <div fxLayout="column" fxLayout.xs="column" fxLayoutAlign="start center" fxFlex.gt-sm="100" class="dis-block">


    <fieldset>
      <legend>Gestión</legend>
      <mat-form-field class="mr-20">
        <mat-label>Coordinador de la empresa</mat-label>
        <mat-select class="full-width-multi-select" formControlName="Coordinador"
            (ngModelChange)="SetFilterValues('EmpresaCoordinador')">
            <mat-option *ngFor="let Cordinadr of filterService.CoordinadorList$" [value]="Cordinadr.viewValue">
                {{Cordinadr.viewValue}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="mr-20">
        <mat-label>Gestor de la empresa</mat-label>
        <mat-select class="full-width-multi-select"  formControlName="Gestor"
            (ngModelChange)="SetFilterValues('Gestor')">
            <mat-option *ngFor="let Gestor of filterService.GestorList$" [value]="Gestor.administrativa">
                {{Gestor.nombre}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</fieldset>


    <fieldset>
      <legend>Trabajador</legend>
      <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start end" fxFlex.gt-sm="100">
        <app-attributes-filter id="filter-leave" [AttributeModal]="filterService.selectedAttribute"
          (AttributeSelected)="SetAttribute($event)" (AttributeModalChanged)="SetAttributeModal($event)">
        </app-attributes-filter>

        <app-consentimiento-filter id="consentimiento-leave"></app-consentimiento-filter>

          <mat-form-field appearance="outline">
            <mat-label>Provincia</mat-label>
            <mat-select 
              name="provinciaSelect"
              [(ngModel)]="selectionService.leaveSelectionModal.Provincia"  [ngModelOptions]="{standalone: true}"
              (ngModelChange)="onProvinciaChange($event)">
              
              <div class="buscador-container">
                <input class="buscador-input" placeholder="Buscar provincia..." 
                      (input)="filtrarProvincias($event)" 
                      (keydown)="$event.stopPropagation()">
              </div>

              @for (prov of filteredProvinceList; track prov.value) {
                <mat-option [value]="prov.value">{{ prov.viewValue }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Población</mat-label>
          <mat-select 
            name="poblacionSelect"
            [(ngModel)]="selectionService.leaveSelectionModal.Poblacion"  [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onPoblacionChange($event)">
            
            <div class="buscador-container">
              <input class="buscador-input" placeholder="Buscar población..." 
                    (input)="filtrarPoblaciones($event)" 
                    (keydown)="$event.stopPropagation()">
            </div>

            @for (pob of filteredPoblacionList; track pob) {
              <mat-option [value]="pob">{{ pob }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        
      </div>
    </fieldset>

    <fieldset>
      <legend>Baja</legend>
      <div fxLayout="row wrap" fxLayoutGap="20px" fxLayout.xs="column" fxLayoutAlign="start end" fxFlex.gt-sm="100">
        <app-leave-type-filter [LeaveTypeControl]="filterService.LeaveType" (LeaveTypeSelected)="SetLeaveType($event)">
        </app-leave-type-filter>
        <div class="widget mr-20" id="leave-selection-doctor">
          <mat-form-field class="full-width-multi-select">
            <mat-label>Médico</mat-label>

            <mat-select panelClass="cus-search-select"  formControlName="Doctor"
              (selectionChange)="SetFilterValues('medico')" [(ngModel)]="defaultDoctorValue">

              <input type="text" autocomplete="off" matInput placeholder="búsqueda" #medicoSelect
                    (input)="SearchDoctors()" />
                <div class="search-options">
                  <mat-option *ngFor="let doctor of _medicoList" [value]="doctor.value">{{doctor.viewValue}}</mat-option>
                </div>
            </mat-select>

          </mat-form-field>
        </div>
        <div class="widget mr-20" id="leave-selection-psychosocial-risks"
          *ngIf="selectionService.selectionPermissions.HasPsychosocialRisks">
          <mat-form-field>
            <mat-label>Riesgos psicosocial</mat-label>
            <mat-select multiple class="full-width-multi-select" formControlName="PsychosocialRisk"
              (ngModelChange)="SetFilterValues('psychosocialRisk')">
              <mat-option *ngFor="let risk of PsychosocialRisks$" [value]="risk.value">{{risk.text}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="widget">
          <label>Bajas por día de semana</label>
          <div class="input-group">
            <mat-form-field class="mr-20">
              <mat-label>Día de la semana</mat-label>
              <mat-select class="full-width-multi-select" formControlName="Weekday"
                (ngModelChange)="SetFilterValues('leavesWeekday')">
                <mat-option *ngFor="let day of DayList$" [value]="day.value">{{day.text}}</mat-option>
              </mat-select>
            </mat-form-field>
            <div>
              <mat-form-field class="mr-20">
                <mat-label>Más de</mat-label>
                <input type="number" matInput formControlName="WeekdayCount"
                  (keyup)="SetFilterValues('leavesWeekdayCount')" autocomplete="off">
              </mat-form-field>

              <mat-error class="m-t--5"
                *ngIf="filterService.LeaveSelectionMoreFilterForm.get('WeekdayCount').invalid && filterService.LeaveSelectionMoreFilterForm.get('WeekdayCount').touched">
                <span *ngIf="filterService.LeaveSelectionMoreFilterForm.get('WeekdayCount').hasError('min')">El valor
                  sería
                  más de 0</span>
                <span *ngIf="filterService.LeaveSelectionMoreFilterForm.get('WeekdayCount').hasError('max')">El valor
                  debería ser inferior a 100</span>
              </mat-error>
            </div>
          </div>
        </div>
      </div>
    </fieldset>

    <fieldset>
      <legend>Fechas</legend>
      <app-date-period-filter [IsBothDatesRequired]="true" [DateType]="DateFilterType.NewLeave"
        [PeriodFrom]="filterService.NewLeaveDateFrom" [PeriodTo]="filterService.NewLeaveDateTo"
        (FromDateChanged)="SetDatePeriodValues(DateFilterType.NewLeave, 'F', $event)"
        (ToDateChanged)="SetDatePeriodValues(DateFilterType.NewLeave, 'T', $event)">
      </app-date-period-filter>

      <app-date-period-filter [IsBothDatesRequired]="true" [DateType]="DateFilterType.Discharge"
        [PeriodFrom]="filterService.DischargeDateFrom" [PeriodTo]="filterService.DischargeDateTo"
        (FromDateChanged)="SetDatePeriodValues(DateFilterType.Discharge, 'F', $event)"
        (ToDateChanged)="SetDatePeriodValues(DateFilterType.Discharge, 'T', $event)">
      </app-date-period-filter>

      <app-date-period-filter [IsBothDatesRequired]="true" [DateType]="DateFilterType.Communication"
        [PeriodFrom]="filterService.CommunicationDateFrom" [PeriodTo]="filterService.CommunicationDateTo"
        (FromDateChanged)="SetDatePeriodValues(DateFilterType.Communication, 'F', $event)"
        (ToDateChanged)="SetDatePeriodValues(DateFilterType.Communication, 'T', $event)">
      </app-date-period-filter>
    </fieldset>

    <fieldset>
      <legend>Dias</legend>
      <div fxLayout="row wrap" fxLayout.xs="column" fxLayoutAlign="start end" fxFlex.gt-sm="100">
        <app-days-filter [DayFilterType]="DaysFilterType.Leave" [DaysFrom]="filterService.LeaveDaysFrom"
          [DaysTo]="filterService.LeaveDaysTo" (DaysFromChanged)="SetDayValues(DaysFilterType.Leave, 'F', $event)"
          (DaysToChanged)="SetDayValues(DaysFilterType.Leave, 'T', $event)">
        </app-days-filter>

        <app-days-filter [DayFilterType]="DaysFilterType.LeaveEndOfPeriod"
          [DaysFrom]="filterService.LeaveEndOfPeriodDaysFrom" [DaysTo]="filterService.LeaveEndOfPeriodDaysTo"
          (DaysFromChanged)="SetDayValues(DaysFilterType.LeaveEndOfPeriod, 'F', $event)"
          (DaysToChanged)="SetDayValues(DaysFilterType.LeaveEndOfPeriod, 'T', $event)">
        </app-days-filter>

        <app-days-filter [DayFilterType]="DaysFilterType.LeaveInPeriod" [DaysFrom]="filterService.LeaveInPeriodDaysFrom"
          [DaysTo]="filterService.LeaveInPeriodDaysTo"
          (DaysFromChanged)="SetDayValues(DaysFilterType.LeaveInPeriod, 'F', $event)"
          (DaysToChanged)="SetDayValues(DaysFilterType.LeaveInPeriod, 'T', $event)">
        </app-days-filter>

        <app-days-filter [DayFilterType]="DaysFilterType.Labor" [DaysFrom]="filterService.LaborDaysFrom"
          [DaysTo]="filterService.LaborDaysTo" (DaysFromChanged)="SetDayValues(DaysFilterType.Labor, 'F', $event)"
          (DaysToChanged)="SetDayValues(DaysFilterType.Labor, 'T', $event)">
        </app-days-filter>
        <app-days-filter [DayFilterType]="DaysFilterType.LaborEndOfPeriod"
          [DaysFrom]="filterService.LaborEndOfPeriodDaysFrom" [DaysTo]="filterService.LaborEndOfPeriodDaysTo"
          (DaysFromChanged)="SetDayValues(DaysFilterType.LaborEndOfPeriod, 'F', $event)"
          (DaysToChanged)="SetDayValues(DaysFilterType.LaborEndOfPeriod, 'T', $event)">
        </app-days-filter>

        <app-days-filter [DayFilterType]="DaysFilterType.LaborInPeriod" [DaysFrom]="filterService.LaborInPeriodDaysFrom"
          [DaysTo]="filterService.LaborInPeriodDaysTo"
          (DaysFromChanged)="SetDayValues(DaysFilterType.LaborInPeriod, 'F', $event)"
          (DaysToChanged)="SetDayValues(DaysFilterType.LaborInPeriod, 'T', $event)">
        </app-days-filter>

        <app-days-filter [DayFilterType]="DaysFilterType.LeaveCommunicationGap"
          [DaysFrom]="filterService.LeaveCommunicationGapDaysFrom" [DaysTo]="filterService.LeaveCommunicationGapDaysTo"
          (DaysFromChanged)="SetDayValues(DaysFilterType.LeaveCommunicationGap, 'F', $event)"
          (DaysToChanged)="SetDayValues(DaysFilterType.LeaveCommunicationGap, 'T', $event)">
        </app-days-filter>
      </div>
    </fieldset>

    <fieldset *ngIf="selectionService.selectionPermissions.HasDiagnosis">
      <legend>Diagnóstico </legend>
      <div fxLayout="row wrap" fxLayoutGap="20px" fxLayout.xs="column" fxLayoutAlign="start end" fxFlex.gt-sm="100">
        <div class="input-group input-group-diagnosis">
          <app-diagnosis-filter></app-diagnosis-filter>
          <div class="widget mr-20 ml-20" fxFlex.gt-sm="50" id="leave-selection-no-diagnosis">
            <mat-checkbox formControlName="NoDiagnosis" (ngModelChange)="SetFilterValues('noDiagnosis')">Sin diagnóstico
            </mat-checkbox>
          </div>
          <div class="widget" fxFlex.gt-sm="50" id="leave-selection-no-reason"
            *ngIf="filterService.LeaveSelectionMoreFilterForm.get('NoDiagnosis').value">
            <mat-form-field>
              <mat-label>Motivo</mat-label>
              <mat-select multiple class="full-width-multi-select" formControlName="NoDiagnosisReason"
                (ngModelChange)="SetFilterValues('noDiagnosisReason')">
                <mat-option *ngFor="let reason of NoDiagnosisReasons$" [value]="reason.value">{{reason.text}}</mat-option>
              </mat-select>
            </mat-form-field>
            
            <!-- <mat-error *ngIf="filterService.LeaveSelectionMoreFilterForm.get('NoDiagnosisReason').errors?.required" class="m-t--15">
              <span *ngIf="filterService.LeaveSelectionMoreFilterForm.get('NoDiagnosisReason').errors?.required">Obligatorio</span>
            </mat-error> -->
          </div>
        </div>
      </div>
    </fieldset>
  
    <fieldset>
      <legend>Marcas</legend>
      <div fxFlex.gt-sm="100">
        <app-marca-filter></app-marca-filter>
      </div>
    </fieldset>

  </div>
</form>